import React from 'react'
import { AphroditeIframe } from '@ui'
import { accessToken } from '@stores/apollo'
import Appbar from '../Appbar'
import { useHRLocations } from '@ui/selects/HRLocationSelect'
import { useUser } from '@hooks'
import { get } from 'lodash'
import LocationFilterNote from 'components/EmployeeManagement/LocationFilterNote'
import { legacyMode } from 'App'

export default function PortfolioProjections({ pinLeftNav }: any) {
  const url = '/ap/Current/projections'
  const locations = useHRLocations()
  const user = useUser()
  const preferredLocation = get(user, 'user.employee.preferredLocations', [])
  const locationFilterNote =
    !legacyMode &&
    (preferredLocation.length === 0 || locations.length === preferredLocation.length ? null : (
      <LocationFilterNote />
    ))
  return (
    <>
      <Appbar title="Projections" locationFilterNote={locationFilterNote} />
      <AphroditeIframe token={accessToken} path={url} pinLeftNav={pinLeftNav} />
    </>
  )
}
